import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="name-suggestions"
// Quick-pick chips that fill the ticket name input (create flow only).
export default class extends Controller {
  static targets = ["input"];

  pick(event) {
    event.preventDefault();
    const value = event.currentTarget.dataset.value;
    if (!this.hasInputTarget) return;
    this.inputTarget.value = value;
    // Fire input + change so any listeners (validation, char counters) react.
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }));
    this.inputTarget.focus();
  }
}
